export default __webpack_public_path__ + "images/logoPhilosophy.90336e6ea2be44e810ce80c946a7c5ec.svg"